<template>
  <v-app>
    <vue-snotify></vue-snotify>
    <div class="hyp-container" dark><router-view /></div>
  </v-app>
</template>

<script>
import {
  DEPLOY_ENV,
  DATADOG_APP_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  AUTH0_TENANT_CONFIGS,
} from "@/common/config";
import { datadogRum } from "@datadog/browser-rum";
import lodashGet from "lodash/get";
import { getDesiredAuthRegion } from "@/common/authenticate";
import { datadogSetUserMetadata } from "@/services/user/user.service";

export default {
  name: "App",
  async mounted() {
    if (DEPLOY_ENV && DATADOG_APP_ID && DATADOG_RUM_CLIENT_TOKEN) {
      let res = datadogRum.init({
        applicationId: DATADOG_APP_ID,
        clientToken: DATADOG_RUM_CLIENT_TOKEN,
        site: "datadoghq.com",
        sampleRate: 100,
        env: DEPLOY_ENV,
        trackInteractions: true,
      });
      datadogSetUserMetadata();
    }

    if (
      AUTH0_TENANT_CONFIGS.length > 1 &&
      !getDesiredAuthRegion() &&
      !(lodashGet(this, "$route.name") === "AuthRegion")
    ) {
      window.location =
        "/auth-region?redirect=" + encodeURI(window.location.href);
    }
  },
};
</script>

<style lang="scss">
.v-application {
  [class*="text-"] {
    font-family: $font-family-light, sans-serif !important;
    font-weight: normal !important;
  }
  font-family: $font-family-light, sans-serif !important;
  font-weight: normal !important;
}
.v-application a {
  font-family: $font-family-light !important;
  font-weight: normal !important;
}
.application {
  font-family: $font-family-light !important;
  font-weight: normal !important;
}
.application-heading {
  font-family: $font-family-regular !important;
  font-weight: normal !important;
}
</style>

<style>
@import "https://api.tiles.mapbox.com/mapbox-gl-js/v1.5.0/mapbox-gl.css";
@import "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.0.9/mapbox-gl-draw.css";

.hyp-container {
  height: 100%;
  background-color: black;
  -webkit-font-smoothing: subpixel-antialiased;
}
</style>
